import { templesGroup1 } from './templesGroup1.js';
import { templesGroup2 } from './templesGroup2.js';
import { templesGroup3 } from './templesGroup3.js';
import { templesGroup4 } from './templesGroup4.js';
import { getTempleMedia } from './templeMedia.js';

const rawTemples = [
  ...templesGroup1,
  ...templesGroup2,
  ...templesGroup3,
  ...templesGroup4,
];

// Enrich each temple with its authentic images
export const templesData = rawTemples.map((t) => {
  const media = getTempleMedia(t.slug);
  return {
    ...t,
    images: {
      ...t.images,
      thumbnailImage: t.images?.thumbnailImage || media.timingImage,
      timingImage: media.timingImage,
      aarti1: media.aarti1,
      aarti2: media.aarti2,
    },
  };
});

export const getTempleBySlug = (slug) => {
  if (!slug) return templesData[0];
  const normalized = slug.toLowerCase().trim();
  return (
    templesData.find((t) => t.slug === normalized) ||
    templesData.find((t) => t.slNo === normalized) ||
    templesData.find(
      (t) =>
        t.generalInfo.templeName.toLowerCase().includes(normalized) ||
        normalized.includes(t.slug)
    ) ||
    templesData[0]
  );
};

export const getTempleBySlNo = (slNo) => {
  return templesData.find((t) => t.slNo === String(slNo)) || templesData[0];
};

export const getAllTemples = () => {
  return templesData.map((t) => ({
    slNo: t.slNo,
    slug: t.slug,
    name: t.generalInfo.templeName,
    location: t.generalInfo.location,
    deity: t.generalInfo.deity,
    image: t.images?.thumbnailImage || '/assets/banner/detail-image.svg',
    bestTime: t.timeInfo?.bestTime || 'Year-round',
    peakTime: t.timeInfo?.peakTime || 'Festivals & Weekends',
  }));
};

export default templesData;
